/** Páginas Amarelas whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { pagAmrlDefaultTheme } from './default';

export { pagAmrlWhitelabel } from './default';

export const pagAmrlWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: pagAmrlDefaultTheme,
  },
};
